import React, { useContext } from 'react';
import { Divider, Stack, TextField } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MdDeleteForever, MdFileDownload, MdVisibility } from 'react-icons/md';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptBRLocale from 'date-fns/locale/pt-BR';
import { Button, FileInfo } from './styled';
import { ReverseCollectContext } from '../../../..';

export const FileList = () => {
  const maxXS = useMediaQuery('(max-width:480px)');

  const {
    invoiceFiles,
    invoiceNumberErrorList,
    invoiceDateErrorList,
    setInvoiceFiles,
    openRemoveInvoiceModal
  } = useContext(ReverseCollectContext);

  const handleSetInvoiceNumber = (event, id) => {
    const { value: invoiceNumber } = event.target;

    const indexFile = invoiceFiles.findIndex((file) => file.id === id);

    const newInvoiceFiles = [...invoiceFiles];

    newInvoiceFiles[indexFile].invoiceNumber = invoiceNumber;

    setInvoiceFiles(newInvoiceFiles);
  };

  const handleSetInvoiceDate = (invoiceDate, id) => {
    const indexFile = invoiceFiles.findIndex((file) => file.id === id);

    const newInvoiceFiles = [...invoiceFiles];

    newInvoiceFiles[indexFile].invoiceDate = invoiceDate;

    setInvoiceFiles(newInvoiceFiles);
  };

  const handleOpenInvoiceFile = (invoiceFile) => {
    const file = new Blob([invoiceFile], { type: invoiceFile.type });
    const fileURL = URL.createObjectURL(file);
    const pdfWindow = window.open();
    pdfWindow.location.href = fileURL;
  };

  const handleDownloadInvoiceFile = (invoiceFile) => {
    const file = new Blob([invoiceFile], { type: invoiceFile.type });
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement('a');
    link.href = fileURL;
    link.setAttribute('download', invoiceFile.name);

    document.body.appendChild(link);

    link.click();

    link.parentNode.removeChild(link);
  };

  return (
    <Stack gap={2} divider={<Divider orientation="horizontal" flexItem />}>
      {invoiceFiles.map(
        ({ id, file, name, readableSize, invoiceNumber, invoiceDate }) => {
          if (file) {
            return (
              <Stack key={id} gap={2} style={{ width: '100%' }}>
                <Stack direction="row" gap={2}>
                  <TextField
                    label="Número Nota Fiscal *"
                    size="small"
                    value={invoiceNumber}
                    onChange={(event) => {
                      const regex = /^[0-9]+$/;
                      if (
                        !event.target.value.match(regex) &&
                        event.target.value !== ''
                      ) {
                        return;
                      }
                      handleSetInvoiceNumber(event, id);
                    }}
                    inputProps={{ maxLength: 10 }}
                    style={{ width: 256 }}
                    error={invoiceNumberErrorList.includes(id)}
                  />

                  <LocalizationProvider
                    dateAdapter={AdapterDateFns}
                    locale={ptBRLocale}
                  >
                    <DatePicker
                      label="Data de saída *"
                      mask="__/__/____"
                      value={invoiceDate}
                      onChange={(value) => {
                        handleSetInvoiceDate(value, id);
                      }}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          {...params}
                          onBlur={(event) => {
                            if (
                              event?.target?.value?.length >= 8 &&
                              event?.target?.value?.length < 10
                            ) {
                              const [day, month, year] =
                                event.target.value.split('/');

                              const newDate = new Date(
                                `20${year?.replace(/^0+/, '')}`,
                                month - 1,
                                day
                              );

                              handleSetInvoiceDate(newDate, id);
                            }
                          }}
                          inputProps={{
                            ...params.inputProps,
                            placeholder: 'DD/MM/AAAA'
                          }}
                          style={{ width: 192 }}
                          error={invoiceDateErrorList.includes(id)}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Stack>

                <Stack direction="row" gap={2}>
                  <Stack
                    direction="row"
                    spacing={4}
                    style={{
                      width: 464,
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <FileInfo>
                      <strong
                        style={{
                          width: maxXS && 140,
                          textOverflow: maxXS && 'ellipsis',
                          overflow: maxXS && 'hidden',
                          whiteSpace: maxXS && 'nowrap'
                        }}
                      >
                        {name}
                      </strong>
                      <span>{readableSize}</span>
                    </FileInfo>

                    <Stack direction="row" gap={1}>
                      {/* eslint-disable-next-line prettier/prettier */}
                      <Button type="button" onClick={() => handleOpenInvoiceFile(file)}>
                        <MdVisibility size={20} />
                      </Button>

                      {/* eslint-disable-next-line prettier/prettier */}
                      <Button type="button" onClick={() => handleDownloadInvoiceFile(file)}>
                        <MdFileDownload size={20} />
                      </Button>

                      <Button
                        type="button"
                        onClick={() => openRemoveInvoiceModal(id)}
                      >
                        <MdDeleteForever size={20} />
                      </Button>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            );
          }
          return null;
        }
      )}
    </Stack>
  );
};
